import { render } from "./HeroiconsSolidTrendingUp.vue?vue&type=template&id=57d2107e"
const script = {}

import exportComponent from "/Users/mq/Projects/siinadmin/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidTrendingUp.vue"]])

export default __exports__